var _rect, _ellipse, _ellipse2, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "url(#paint0_linear_69_37)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4348,
    cy: 28.5858,
    rx: 2.94203,
    ry: 2.9,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 28.5858,
    rx: 2.94203,
    ry: 2.9,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5652,
    cy: 28.5858,
    rx: 2.94203,
    ry: 2.9,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_37",
    x1: 29,
    y1: 0,
    x2: 29,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CD0FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#255DA2",
    stopOpacity: 0.843229
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494FDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMoreIcon);
export default __webpack_public_path__ + "static/media/seeMoreIcon.4d1ac0da7b2181251f620f0dac7bb83a.svg";
export { ForwardRef as ReactComponent };